import { render, staticRenderFns } from "./TooltipPosition.vue?vue&type=template&id=063a77a6&"
import script from "./TooltipPosition.vue?vue&type=script&lang=js&"
export * from "./TooltipPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports